/** Safari circuits and travel zones in Tanzania */
export const REGIONS = [
  {
    id: 'northern',
    name: 'Northern Safari Circuit',
    description:
      'Classic wildlife safaris, the Great Migration, Ngorongoro Crater, and Kilimanjaro.',
  },
  {
    id: 'southern',
    name: 'Southern Safari Circuit',
    description:
      'Remote parks with fewer crowds, elephants, predators, and river safaris.',
  },
  {
    id: 'western',
    name: 'Western Tanzania',
    description: 'Chimpanzee trekking on the shores of Lake Tanganyika.',
  },
  {
    id: 'coastal',
    name: 'Coast & Islands',
    description: 'Indian Ocean beaches, Stone Town heritage, and spice tours.',
  },
];

export function getRegionById(id) {
  return REGIONS.find((region) => region.id === id);
}
